// Copyright 2024 Sorama B.V.
/* eslint-disable @typescript-eslint/no-explicit-any */
// Copyright 2016 Sorama B.V.

import { autoinject, bindable, customElement } from "aurelia-framework";

@customElement("mjpeg-streamer")
@autoinject
export class MJPEGStreamer {
    private controlContainer: HTMLDivElement;

    private isFullScreen = false;

    public controlId: number = new Date().getTime();

    @bindable()
    public uri: string;

    @bindable()
    public elementStyle: string;

    @bindable()
    public maximizeButton = false;

    public bind(): void {
        // Create a mutation observer for the parent node of this control
        document.addEventListener("fullscreenchange", this.fullscreenChanged);
    }

    public unbind(): void {
        document.removeEventListener("fullscreenchange", this.fullscreenChanged);
    }

    private fullscreenChanged = (): void => {
        this.isFullScreen = !!document.fullscreenElement;
    };

    public toggleFullScreen(): void {
        if (this.isFullScreen) {
            document.exitFullscreen();
        } else {
            this.controlContainer.requestFullscreen();
        }
    }
}
